<template>
  <span class="order-container">
    <template v-if="hasItems">
      <div class="order-grid">
        <v-card
          v-for="(order, index) in getOrderHistory"
          :key="`order_history_${index}`"
          class="order-card"
          :class="{ 'expanded': expandedCards[order.orderId] }"
          elevation="1"
          hover
        >
          <OrderHistoryItem
            :order="order"
            :expanded="expandedCards[order.orderId]"
            @expand="toggleCard(order.orderId)"
          />
        </v-card>
      </div>

      <v-btn
        outlined
        :disabled="!getHasMoreOrderHistoryPages || getIsFetchingOrderHistory"
        :loading="getIsFetchingOrderHistory"
        :block="$vuetify.breakpoint.smAndDown"
        color="primary"
        class="load-more-btn mt-6"
        @click="fetchOrderHistoryPage"
      >
        {{ $vuetify.t('$vuetify.common.loadMore') }}
      </v-btn>
    </template>
  </span>
</template>

<script>
import OrderHistoryItem from '@/components/Account/OrderHistoryItem.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
    data() {
        return {
            expandedCards: {}
        }
    },
    components: {
        OrderHistoryItem
    },
    computed: {
        ...mapGetters([
            'getOrderHistory',
            'getHasMoreOrderHistoryPages',
            'getIsFetchingOrderHistory'
        ]),
        hasItems() {
            return Array.isArray(this.getOrderHistory)
                ? this.getOrderHistory.length > 0
                : false
        }
    },
    methods: {
        ...mapActions(['fetchOrderHistoryPage']),
        toggleCard(orderId) {
        this.$set(this.expandedCards, orderId, !this.expandedCards[orderId])
        }
    }
}
</script>
<style scoped>
.order-container {
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 24px;
}

.order-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    align-items: start;
}

.order-card {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease;
    border-radius: 8px;
    overflow: hidden;
}

.order-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.order-card.expanded {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12) !important;
}

.load-more-btn {
    max-width: 200px;
    margin: 32px auto;
    height: 48px;
    font-weight: 500;
    letter-spacing: 0.5px;
    border-radius: 24px;
}

@media (max-width: 959px) {
    .order-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
    }
    
    .order-container {
        padding: 16px;
    }
}

@media (max-width: 599px) {
    .order-grid {
        grid-template-columns: 1fr;
        gap: 12px;
    }

    .order-container {
        padding: 12px;
    }

    .load-more-btn {
        max-width: 100%;
    }
}
</style>